import React from "react";
import { SparklesIcon, TargetIcon, UsersIcon } from "../Icons";
import { DESIGN_STEPS } from "./content";

const STEP_ICONS = [UsersIcon, TargetIcon, SparklesIcon];

export default function DesignSteps() {
  return (
    <ol className="tw-mt-8 tw-mb-0 tw-grid tw-list-none tw-grid-cols-3 tw-gap-5 tw-p-0 sm:tw-grid-cols-1">
      {DESIGN_STEPS.map((step, index) => {
        const Icon = STEP_ICONS[index];

        return (
          <li
            key={step.title}
            className="tw-min-w-0 tw-rounded-2xl tw-border tw-border-[#d5e4ef] tw-bg-white tw-p-5"
          >
            <Icon aria-hidden className="tw-h-5 tw-w-5 tw-shrink-0 tw-text-[#087bd3]" />
            <h3 className="tw-mt-4 tw-mb-0 tw-text-base tw-font-black tw-text-[#1c3854]">
              {step.title}
            </h3>
            <p className="tw-mt-2 tw-mb-0 tw-text-sm tw-leading-6 tw-text-[#60768c]">{step.body}</p>
          </li>
        );
      })}
    </ol>
  );
}
